import React from 'react';
import { CTAButton } from './CTAButton';
import { TrustRow } from './TrustRow';
import { CHECKOUT_URL, PRICE_FULL, PRICE_TODAY, PRODUCT_ALT, PRODUCT_IMG, PRODUCT_NAME, PRODUCT_TAGLINE } from './constants';
const included = ['6 Complete Professional Modules', '5 Premium Bonuses', 'Ready-to-Coach Sessions', 'Exercise & Modification Libraries', 'Programming Systems', 'Client Management Resources', 'Professional Coaching Tools'];
export function PricingCard() {
  return <section id="offer" className="border-y-4 border-pf-coral bg-pf-cream px-3 py-3 sm:px-4 sm:py-4" data-id="element-162" data-mp="29tlxrazrmzwg">
      <div className="mx-auto max-w-2xl" data-id="element-163" data-mp="252doqg2clgjt">
        <div className="mb-1.5 text-center" data-id="element-164" data-mp="2512lchcteat8">
          <p className="mb-0.5 font-display text-[10.5px] font-bold uppercase tracking-[0.16em] text-pf-coral sm:text-sm" data-id="element-165" data-mp="2123h6yywqi2u">
            Special Launch Offer
          </p>
          <h2 className="mb-0.5 font-display text-[22px] font-extrabold uppercase leading-none tracking-tight sm:text-4xl" data-id="element-166" data-mp="2xlaud3jmeaj7">
            🤰 {PRODUCT_NAME}
          </h2>
          <p className="font-display text-[12px] font-bold uppercase text-pf-navy sm:text-lg" data-id="element-167" data-mp="32kub89lqtgqn">
            {PRODUCT_TAGLINE}
          </p>
          <p className="mb-1 text-[12px] font-semibold text-pf-ink sm:text-base" data-id="element-168" data-mp="2suj125bgubbb">
            Complete 6-in-1 Prenatal Fitness Coaching System
          </p>
          <a href={CHECKOUT_URL} className="block" aria-label={`Buy ${PRODUCT_NAME}`} data-id="element-169" data-mp="2xs19lulkmois">
            <img src={PRODUCT_IMG} alt={PRODUCT_ALT} className="mx-auto mb-1.5 w-full max-w-[210px] object-contain drop-shadow-xl transition-transform duration-200 ease-out hover:scale-[1.02] sm:max-w-[250px]" data-id="element-170" data-mp="2jt1mwshmcjp9" />
          </a>
        </div>

        <div className="mb-1.5 rounded-xl border-4 border-pf-coral bg-white p-3 text-center shadow-2xl sm:p-4" data-id="element-171" data-mp="2evj8wnoqveae">
          <ul className="mb-1 grid gap-x-3 gap-y-0.5 text-left text-[12px] font-bold text-pf-navy sm:grid-cols-2 sm:text-[15px]" data-id="element-172" data-mp="84tibh7n65dc">
            {included.map(item => <li key={item} data-id="element-173" data-mp="bmhj41ancby0">✅ {item}</li>)}
          </ul>
          <p className="text-[12.5px] font-medium text-pf-ink" data-id="element-174" data-mp="6n4ogudja0kv">
            Regular Price: <span className="line-through" data-id="element-175" data-mp="6p7kbv1danxi">{PRICE_FULL}</span>
          </p>
          <p className="mb-1.5 font-display text-[22px] font-extrabold uppercase leading-tight tracking-tight text-pf-coral sm:text-4xl" data-id="element-176" data-mp="1ojwtjcckp81">
            🔥 TODAY ONLY: {PRICE_TODAY}
          </p>
          <CTAButton href={CHECKOUT_URL} data-id="element-177" data-mp="ube75nfga87s">🤰 YES! I WANT PRENATAL FITNESS COACH PRO™</CTAButton>
          <p className="mt-1 text-[11px] font-bold text-pf-navy sm:text-sm" data-id="element-178" data-mp="pexf4i54r9pf">
            Immediate Digital Access
          </p>
        </div>

        <TrustRow showAccess={false} guaranteeLabel="🛡️ 14-Day Money-Back Guarantee" data-id="element-179" data-mp="kkji6batkuin" />
      </div>
    </section>;
}